export default {
  referrals: [],
  usersWithRefferals: [],
}
